import {
	Table, Row, Checkbox, Tag, Popconfirm, Pagination
}from 'antd'
import {
	useEffect,
	useState
}from 'react'
import {
	useSelector, useDispatch
}from 'react-redux'
import './style.css'
import {
	reInfoOrgActions
}from './store/actions'
import Notifications from '../../helpers/Notifications'
import {
	useDebounce
}from 'use-debounce'
import AddReInfoOrgByFile from './addFromFile'
import AddReInfoOrg from './add'
import ChangeReInfoOrg from './change'
import CustomButton from '../../components/CustomButton'
import DeleteIcon from '../../components/Icons/delete.svg'
import RestoreIcon from '../../components/Icons/restore.svg'
import UpdateIcon from '../../components/Icons/update.svg'
import LocalLoading from '../../components/Loading/Local'
import {
	reInfoOrgTypeActions
}from '../NRI/ReInfoOrgType/store/actions'
import CustomFilters from '../../components/CustomFilters'
import {
	rePriceFormationOrderActions
}from '../NRI/RePriceFormationOrder/store/actions'
import axios from 'axios'
const ReInfoOrg = ({ isModify = true }) => {
	const [addVisible, setAddVisible] = useState(false)
	const [addFromFileVisible, setAddFromFileVisible] = useState(false)
	const [changeVisible, setChangeVisible] = useState(false)
	const [record, setRecord] = useState(null)
	const [auditLoading, setAuditLoading] = useState(false)
	const [table, setTable] = useState([])
	const [count, setCount] = useState(0)
	const [searchReOrg, setSearchReOrg] = useState(null)
	const [filter, setFilter] = useState({ page     : 1,
		pageSize : 10 })
	const [searchReOrgValue] = useDebounce(searchReOrg, 300)
	const dispatch = useDispatch()

	const { paged, changed, isSending, list } = useSelector(state => state.reInfoOrgReducer)
	const { list: prices } = useSelector(state => state.rePriceFormationOrderReducer)
	const { list: types } = useSelector(state => state.reInfoOrgTypeReducer)
	const getReOrg = (values) => {
		dispatch(reInfoOrgActions.getList(values))
	}
	const getPaged = (values) => {
		dispatch(reInfoOrgActions.getPaged(values))
	}
	const getPagedAll = (values) => {
		dispatch(reInfoOrgActions.getPagedAll(values))
	}
	const create = (values) => {
		dispatch(reInfoOrgActions.create(values))
	}
	const update = (values) => {
		dispatch(reInfoOrgActions.update(values))
	}
	const remove = (values) => {
		dispatch(reInfoOrgActions.remove(values))
	}
	const restore = (values) => {
		dispatch(reInfoOrgActions.restore(values))
	}
	const upload = (values) => {
		dispatch(reInfoOrgActions.upload(values))
	}
	const getExampleFile = (values) => {
		dispatch(reInfoOrgActions.getExampleFile(values))
	}
	const getFile = (values) => {
		dispatch(reInfoOrgActions.getFile(values))
	}
	const getRePriceFormOrderList = (values) => {
		dispatch(rePriceFormationOrderActions.getList(values))
	}
	const getReInfoOrgTypes = (values) => {
		dispatch(reInfoOrgTypeActions.getList(values))
	}

	const onPaginationChange = (value) => {
	  setFilter({ ...filter,
			page: value })
	}

	useEffect(() => {
		if (searchReOrgValue?.trim()?.length > 1){
			getReOrg({
				name     : searchReOrgValue.trim(),
				pageSize : 10,
				isActual : Boolean(!isModify)
			})
		}
	}, [searchReOrgValue])

	useEffect(() => {
		isModify ? getPagedAll(filter) : getPaged(filter)
	}, [filter])

	useEffect(() => {
		getRePriceFormOrderList()
		getReInfoOrgTypes()
		return () => {
			dispatch(reInfoOrgActions.clear())
			dispatch(reInfoOrgTypeActions.clear())
			dispatch(rePriceFormationOrderActions.clear())
		}
	}, [])

	useEffect(() => {
		if (changed){
			Notifications.successNotice(changed, "", 15)
			onPaginationChange(filter.page)
		}
	}, [changed])

	useEffect(() => {
		if (paged?.items){
			setCount(paged.count)
			setTable(paged.items)
		}
	}, [paged])

	const columns = [
		{
			dataIndex : 'unp',
			key       : 'unp',
			title     : 'УНП',
			width     : "7%"
		},
		{
			dataIndex : 'fullName',
			key       : 'fullName',
			title     : 'Наименование',
			width     : '40%'
		},
		{
			dataIndex : 'type',
			key       : 'type',
			title     : 'Категория',
			width     : '11%'
		}
	]

	isModify && columns.push({
		dataIndex : 'isUsePossibleRegion',
		key       : 'isUsePossibleRegion',
		render    : (checked) => (
			<Checkbox
				checked={ checked }
			/>
		),
		title : 'Использование возможных регионов реализации',
		width : '7%'
	}, {
		dataIndex : 'prices',
		key       : 'priceOrders',
		render    : (priceOrders) => (
			<span>
				  { priceOrders?.map((price) => {
					return (
						<Tag
							key={ price.id }
							className="priceTag"
						>
							<div>
								{ price.name }
							</div>
						</Tag>
					)
				  }) }
			</span>
			  ),
		title : 'Порядок формирования цены',
		width : '23%'
	}, {
		dataIndex : 'createDate',
		inputType : 'text',
		key       : 'createDate',
		title     : 'Дата добавления',
		width     : '5%'
	}, {
		dataIndex : 'id',
		key       : 'id',
		width     : '7%',
		render    : (id, obj) => (
			<div className="changeIcon">
				<img
					src={ UpdateIcon }
					onClick={ () => {
						setChangeVisible(true)
						setRecord(obj)
					} }
				/>
				<Popconfirm
					cancelText="Нет"
					okText="Да"
					placement="left"
					title={ obj.isDeleted
						? 'Вы действительно хотите восстановить организацию?'
						: 'Вы действительно хотите удалить организацию?' }
					onCancel={ (e) => {
						e.preventDefault()
						return null
					} }
					onConfirm={ (e) => {
						e.preventDefault()
						obj.isDeleted ? restore({ id }) : remove({ id })
					} }
				>
					<img
						src={ !obj.isDeleted ? DeleteIcon : RestoreIcon }
						title={ !obj.isDeleted ? "Удалить" : "Восстановить" }
					/>
				</Popconfirm>
			</div>
		)
	})

	const customFilters = [
		{
			name        : "name",
			type        : "autoComplete",
			placeholder : "Введите название/УНП организации",
			items       : list.map(item => ({ name      : item.fullName,
				isDeleted : item.isDeleted })),
			onSearch: (value) => setSearchReOrg(value)
		},
		{
			name        : "types",
			type        : "select",
			multiple    : true,
			placeholder : "Выберите категорию организации",
			items       : types,
			itemName    : ["name"]
		}
	]

	isModify && customFilters.push({
		name        : "prices",
		type        : "select",
		multiple    : true,
		placeholder : "Выберите порядок формирования цены",
		items       : prices,
		itemName    : ["name"]
	})

	return (
		<>
			<div className="select-page">
				{ !isModify && (
					<h1 style={ { textAlign: "center" } }>
						Перечень юридических лиц и индивидуальных предпринимателей, предоставляющих данные в ИСС в обязательном порядке
					</h1>
				) }
				<CustomFilters
					elements={ customFilters }
					setFilters={ (values) => {
						setFilter({ 							...filter,
							...values,
							page: 1 })
					} }
				/>
				{ isModify && (
					<Row className="buttons-add">
						<CustomButton
							onClick={ () => {
								setAddVisible(true)
							} }
						>
						Добавить организацию
						</CustomButton>
						<CustomButton
							onClick={ () => {
								setAddFromFileVisible(true)
							} }
						>
						Добавить организацию через файл
						</CustomButton>
					</Row>
				) }
				<Table
					columns={ columns }
					dataSource={ table }
					loading={ { indicator : <LocalLoading />,
						spinning  : isSending } }
					pagination={ false }
					scroll={ { x: 1200 } }
				/>
				{ count > filter.pageSize
					? (
						<Pagination
							showQuickJumper
							current={ filter.page }
							pageSize={ filter.pageSize }
							showSizeChanger={ false }
							size="small"
							style={ { marginTop: isModify ? "0px" : "30px" } }
							total={ count }
							onChange={ onPaginationChange }
						/>)
					: null }
			</div>
			<AddReInfoOrg
				create={ create }
				pageSize={ filter.pageSize }
				prices={ prices }
				setVisible={ setAddVisible }
				types={ types }
				visible={ addVisible }
			/>
			<ChangeReInfoOrg
				prices={ prices }
				record={ record }
				setRecord={ setRecord }
				setVisible={ setChangeVisible }
				types={ types }
				update={ update }
				visible={ changeVisible }
			/>
			<AddReInfoOrgByFile
				getExampleFile={ getExampleFile }
				getFile={ getFile }
				setVisible={ setAddFromFileVisible }
				upload={ upload }
				visible={ addFromFileVisible }
			/>
		</>
	)
}

export default ReInfoOrg